module.exports = __webpack_public_path__ + "img/lazyload.7677edd5.gif";